const initialState = {
	data: [],
	total: 0,
	params: {},
	selectedSettingLanguage: {},
	sidebarOpen: false,
	sidebarStatus: 'add',
}

const settinglanguage = (state = initialState, action) => {
	switch (action.type) {
		case 'SETTINGLANGUAGE_GET_DATA':
			return {
				...state,
				data: action.data,
				total: action.total,
				params: action.params,
			}
		case 'SETTINGLANGUAGE_ADD_DATA':
			return {
				...state,
				data: [...state.data, action.data],
				total: state.total + 1,
			}
		case 'SETTINGLANGUAGE_UPDATE_DATA':
			return {
				...state,
				data: state.data.map((item) => (item.id === action.index ? action.data : item)),
			}
		case 'SETTINGLANGUAGE_DEL_DATA':
			return {
				...state,
				data: state.data.filter((item) => item.id !== action.index),
				total: state.total - 1,
			}
		case 'SETTINGLANGUAGE_GET_CURRENT':
			return {
				...state,
				selectedSettingLanguage: action.selectedSettingLanguage,
			}
		case 'SETTINGLANGUAGE_SET_SIDEBAR':
			return {
				...state,
				sidebarStatus: action.status,
				sidebarOpen: !state.sidebarOpen,
			}
		default:
			return state
	}
}

export default settinglanguage
